<template>
	<!-- BEGIN register -->
	<div class="register register-with-news-feed">
		<!-- BEGIN news-feed -->
		<div class="news-feed">
			<div class="news-image" style="background-image: url(/assets/img/login-bg/login-bg-15.jpg)"></div>
			<div class="news-caption">
				<h4 class="caption-title"><b>Color</b> Admin App</h4>
				<p>
					As a Color Admin app administrator, you use the Color Admin console to manage your organization’s account, such as add new users, manage security settings, and turn on the services you want your team to access.
				</p>
			</div>
		</div>
		<!-- END news-feed -->

		<!-- BEGIN register-container -->
		<div class="register-container">
			<!-- BEGIN register-header -->
			<div class="register-header mb-25px h1">
				<div class="mb-1">Sign Up</div>
				<small class="d-block fs-15px lh-16">Create your Color Admin Account. It’s free and always will be.</small>
			</div>
			<!-- END register-header -->

			<!-- BEGIN register-content -->
			<div class="register-content">
				<div class="note note-danger note-with-end-icon mb-2" v-if="alert">
					<div class="note-icon"><i class="fa fa-frown"></i></div>
					<div class="note-content">
						<h4><b>Oops!</b></h4>
						<p>{{error}}</p>
					</div>
				</div>
				<form v-on:submit="handleSubmit" method="POST" class="fs-13px">
					<div class="mb-3">
						<label class="mb-2">Name <span class="text-danger">*</span></label>
						<div class="row gx-3">
							<div class="col-md-6 mb-2 mb-md-0">
								<input type="text" class="form-control fs-13px" placeholder="First name" v-model="first_name" required/>
							</div>
							<div class="col-md-6">
								<input type="text" class="form-control fs-13px" placeholder="Last name" v-model="last_name" required/>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<label class="mb-2">Email <span class="text-danger">*</span></label>
						<input type="text" class="form-control fs-13px" placeholder="Email address" v-model="email" required/>
					</div>
					<div class="mb-3">
						<label class="mb-2">Re-enter Email <span class="text-danger">*</span></label>
						<input type="text" class="form-control fs-13px" placeholder="Re-enter email address" v-model="email_confirm" required/>
					</div>
					<div class="mb-4">
						<label class="mb-2">Password <span class="text-danger">*</span></label>
						<input type="password" class="form-control fs-13px" placeholder="Password" v-model="password" required/>
					</div>
					<div class="mb-4">
						<label class="mb-2">Confirm Password <span class="text-danger">*</span></label>
						<input type="password" class="form-control fs-13px" placeholder="Confirm Password" v-model="password_confirm" required/>
					</div>
					<div class="form-check mb-4">
						<input class="form-check-input" type="checkbox" value="" id="agreementCheckbox" />
						<label class="form-check-label" for="agreementCheckbox">
							By clicking Sign Up, you agree to our <a href="javascript:;">Terms</a> and that you have read our <a href="javascript:;">Data Policy</a>, including our <a href="javascript:;">Cookie Use</a>.
						</label>
					</div>
					<div class="mb-4">
						<button type="submit" class="btn btn-primary d-block w-100 btn-lg h-45px fs-13px">Sign Up</button>
					</div>
					<div class="mb-4 pb-5">
						Already a member? Click <router-link to="/user/login-v3">here</router-link> to login.
					</div>
					<hr class="bg-gray-600 opacity-2" />
					<p class="text-center text-gray-600">
						&copy; Color Admin All Right Reserved 2021
					</p>
				</form>
			</div>
			<!-- END register-content -->
		</div>
		<!-- END register-container -->
	</div>
	<!-- END register -->
</template>

<script>
import axios from 'axios'
import AppOptions from '../../config/AppOptions.vue'

export default {
	name: 'Register',
	data(){
		return{
		'first_name':'',
		'last_name':'',
		'email':'',
		'email_confirm':'',
		'password':'',
		'password_confirm':'',
		error:'',
		alert: false
		}
	},
	created() {
		AppOptions.appEmpty = true;
	},
	beforeRouteLeave (to, from, next) {
		AppOptions.appEmpty = false;
		next();
	},
	methods: {
		async handleSubmit(e){
			e.preventDefault();
			const data = {
				'first_name': this.first_name,
				'last_name': this.last_name,
				'email': this.email,
				'email_confirm': this.email_confirm,
				'password': this.password,
				'password_confirm': this.password_confirm,
				error:'',
				alert: false
			}
			try{
				await axios.post('register', data);
				console.log(data);
				this.$router.push({ path: '/login'});
			}catch(e){
				this.alert = true;
				this.error = 'Error ocurred';
				console.log('error');
			}
		}
	}
}
</script>